import { format, differenceInCalendarDays as differenceInCalendarDaysFNS, addMinutes, subMinutes } from "date-fns";
import { getOffset, toDate } from "../TimeZoneHelper";

/**
 * Wrapper around Date-Fns so Public/Secure Integration don't need to import date-fns
 *
 * @param {date} date
 * @param {object} options
 */
export const formatSimpleDate = (date, options = {}) => {
  const {
    pattern = "DD/MM/YYYY"
  } = options;
  return format(date, pattern, {
    convertTimeZone: false
  });
};
export const formatRating = rating => {
  if (!rating) {
    return "n/a";
  }
  return `${parseInt(rating, 10)}%`;
};
export const formatDate = (dateValue, profile, config, locale) => {
  let defaultDateFormat = "Do MMMM, YYYY";
  if (!dateValue) {
    return "";
  }
  if (profile && config) {
    config.map(item => {
      if (profile.country === item.countryCode && profile.language === item.languageCode) {
        defaultDateFormat = item.dateFormat;
      }
    });
  }
  return `${format(dateValue, defaultDateFormat, {
    locale
  })}`;
};
export const differenceInCalendarDays = (leftDate, rightDate) => {
  return differenceInCalendarDaysFNS(leftDate, rightDate);
};

/**
 * Returns the time in MS according to the given timzone
 *
 * All these Debug's are for LD-1098 Chrome 77 issue!
 *
 * @param {Date} date
 * @param {object} timeZone
 */
export const getDateForTimeZone = (inputDate, timeZone = {}) => {
  const log = {
    debug: () => {} //a => console.warn(a) //eslint-disable-line
  };
  //default to UTC in case there is not timezone specified
  const {
    value = "UTC"
  } = timeZone;
  //handles string date and number ms date
  const date = toDate(inputDate);
  log.debug(timeZone);
  log.debug(Math.abs(date.getTimezoneOffset()));
  //firstly convert the input date to UTC as date object come backed with user timezone
  const utcDate = adjustDateToUTC(date);
  log.debug(utcDate.getTime());
  //find out how many minutes we are away from UTC for the target timezone
  try {
    const offsetInMinutes = getOffset(value, utcDate);
    log.debug(`offset ${offsetInMinutes}`);
    //the zonedDate is the data adjusted to the users desired timezone
    const zonedDate = adjustDate(utcDate, offsetInMinutes);
    log.debug(zonedDate);
    log.debug(zonedDate.getTime());
    return zonedDate;
  } catch (error) {
    console.warn("Failed to localise time "); //eslint-disable-line

    return utcDate;
  }
};
const adjustDateToUTC = (date, offset) => {
  const offsetInMinutes = offset ? offset : date.getTimezoneOffset();
  let utcDate = null;
  if (Math.sign(offsetInMinutes) === -1) {
    utcDate = addMinutes(date, Math.abs(offsetInMinutes));
  } else {
    utcDate = subMinutes(date, offsetInMinutes);
  }
  return utcDate;
};
const adjustDate = (date, offsetInMinutes) => {
  let adjustedDate = null;
  //if negative, subtract minutes
  if (Math.sign(offsetInMinutes) === -1) {
    //Math.abs convert negative to positive
    adjustedDate = subMinutes(date, Math.abs(offsetInMinutes));
  } else {
    adjustedDate = addMinutes(date, offsetInMinutes);
  }
  return adjustedDate;
};

/**
 * Formats a date taking into account a desired timezone
 *
 * @param {date|string} inputDate
 * @param {string} formatString
 * @param {object} timeZone
 */
export const formatToTimeZone = (inputDate, formatString, timeZone = {}) => {
  const {
    value = "UTC"
  } = timeZone;
  //handles string date and number ms date
  const date = toDate(inputDate);
  const offsetInMinutes = getOffset(value, new Date());
  //the zonedDate is the data adjusted to the users desired timezone
  let zonedDate = date;
  //if the offset === 0 i.e. they want to see UTC, show
  if (offsetInMinutes !== 0) {
    zonedDate = adjustDateToUTC(date, offsetInMinutes);
  }
  return formatSimpleDate(getUTCDate(zonedDate), {
    pattern: formatString
  });
};
const getUTCDate = (dateString = Date.now()) => {
  const date = new Date(dateString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
};